import { Hammer } from 'lucide-react';
import { apiService, PackRecipeDTO } from '@/services/api.service';
import { ConfigCatalog } from '@/components/config/ConfigCatalog';
import { RecipeEditor } from '@/components/config/RecipeEditor';
import styles from '@/components/config/PackDetail.module.scss';

const TYPE_LABELS: Record<string, string> = {
  shaped: 'Craft',
  shapeless: 'Sans forme',
  furnace: 'Four',
};

export function CraftsPage() {
  return (
    <ConfigCatalog<PackRecipeDTO>
      title="Crafts"
      icon={Hammer}
      kind="craft"
      load={async (g) => (await apiService.getPackRecipes(g)).data?.recipes ?? []}
      keyOf={(r) => r.identifier}
      identifierOf={(r) => r.identifier}
      thumbnailOf={(r) => r.resultIcon}
      statusOf={(r) => <span className={styles.chip}>{TYPE_LABELS[r.type] ?? r.type}</span>}
      matches={(r, q) => r.identifier.toLowerCase().includes(q) || r.type.toLowerCase().includes(q)}
      sourceOf={(r) => r.source}
      renderDetail={(r, g, reload) => <RecipeEditor identifier={r.identifier} thumbnail={r.resultIcon} groupId={g} onSaved={reload} />}
    />
  );
}
